<div class="modal-body allocate-pbx-popup">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>equipment.details.modals.allocate-pbx.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close"></i>
        </button>
      </div>
      <form>
        <label for="company" translate>equipment.details.modals.allocate-pbx.company-label</label>
        <div class="form-group vox-input-group_dense">
          <gdp-company-search [formControl]="company"></gdp-company-search>
        </div>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary"
            [disabled]="company.value === null || company.value === ''"
            (click)="allocateToPbx()"
            [ladda]="loadingAllocate"
            data-spinner-color="grey"
            data-style="zoom-in"
            type="submit">
            <span translate>equipment.details.modals.allocate-pbx.allocate-button</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
